import {UnknownStructuredTable} from 'notebook/structured-tables/StructuredTableConstants';
import {STRUCTURED_TABLE_PLUGIN} from 'notebook/structured-tables/StructuredTablePlugin';
import {Table} from 'notebook/tables/constants/TableConstants';

export default function convertStructuredTableToTable(structuredTable: UnknownStructuredTable): Table {
  return STRUCTURED_TABLE_PLUGIN.get(structuredTable.kind).toTable(structuredTable);
}
